<template>
  <div class="form-group form-group--radio" :class="classes" >
    <div class="form-element__container">

      <!-- Control and label -->
      <div class="form-control__container">        
        <input type="radio" :id="control_id" ref="controlEl" @focus="fcOnFocus" @blur="fcOnBlur" class="form-control" :value="radioValue" v-model="control_value" v-bind="$attrs"  >
        <label v-if="label" :for="control_id" class="form-control__label">
          <div class="form-control__indicator-wrapper">
            <div class="form-control__indicator form-control__indicator--focus"></div>
            <n-icon class="form-control__indicator form-control__indicator--checked">flavour_pepper</n-icon>
            <n-icon class="form-control__indicator form-control__indicator--unchecked">outline_circle</n-icon>
          </div>
          <slot name="label" :label="label">{{label}}</slot>
        </label>
      </div>
    </div>

    <div class="flexbox row form-control__additional-content-slot">
      <!-- Errors -->
      <div v-if="show_error" class="form-control__error-text">{{errors[0]}}</div> 
      <!-- Helper slot -->
      <div v-else-if="$slots['help'] || $slots['default']" class="form-control__helper-text"> <!-- if there is no help, but default content, render an empty help block for flex spacing -->
        <slot name="help"></slot>
      </div>
      <!-- Default slot -->
      <slot></slot>
    </div>

  </div>
</template>

<script>
import FormControl from '../../mixins/form-control'
import Validatable from '../../mixins/validatable'

export default {

  name: 'NRadio',

  props: {
    radioValue: {  },
  },

  mixins: [FormControl, Validatable],
}
</script>